import { Component } from '@angular/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SimpleListComponent } from '../simple-list';
import { CardComponent } from '../../@theme/components/card/card.component';
import { NgScrollbar } from 'ngx-scrollbar';
import { FieldTextModule } from '../inputs';
import { AuthResourceService } from '@mri/app/resources';

@Component({
  selector: 'app-change-property-dialog',
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatDialogClose,
    MatDialogActions,
    SimpleListComponent,
    CardComponent,
    NgScrollbar,
    FieldTextModule
  ],
  template: `
    <h2 mat-dialog-title>
      Cambiar propietario
    </h2>

    <mat-dialog-content>
      <app-field-text label="Buscar ..." [(value)]="search"></app-field-text>

      <app-card padding="0" [showHeader]="false">
        <app-simple-list
          elementsUrl="properties/choice"
          mode="options"

          [search]="search"
          (valueChange)="valueChange($event)"
        />
      </app-card>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>
        Cancelar
      </button>
    </mat-dialog-actions>
  `
})
export class ChangePropertyDialogComponent {

  search: string = '';

  constructor(
    private _authSrv: AuthResourceService,
  ) {
  }

  valueChange(values: Array<string>) {

    this._authSrv.selectProperty(values[0])
      .subscribe();
  }

}
